<template>
  <span>
    <li class='blueTextCon-i' v-for="(item,index) in blueContent" :key="index" @click.stop="jump(item.url)">
      <span class="blueTextCon-t">{{item.name}}</span><span class="blueTextCon-c"> : {{item.text}}</span>
    </li>
  </span>
</template>
<script>
export default {
  name: 'deliverableDetail',
  props:{
    contentId:String
  },
  data(){
    return{
      blueContent:[],
    }
  },
  mounted(){
    var url = '/zciid-deliverable/api/webapp/app/relation/deliverablesDataPath.json',
        data = {contentId:this.contentId,isMedia:this.getQuery('isMedia')}
    this.$http
      .get(url, data).then(res => {
        if (res.state == 1 && res.data.length) {
          this.blueContent = res.data;
        }else{
          this.$emit('showOrFalse');
        }
      })
  },
  methods:{
    jump(url){
      // window.location.href = url;
      this.open(url,'_self');
    }
  }
}
</script>
<style lang="scss" scoped>
  .blueTextCon-i{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .blueTextCon-i .blueTextCon-t{
    font-weight:900;
    color:#333;
  }
  .blueTextCon-i:hover{
    text-decoration:underline;
    text-underline-position: under;
  }
  .blueTextCon-i:hover .blueTextCon-t,.blueTextCon-i:hover .blueTextCon-c{
    color:#0c78cf !important;
  }
  .blueTextCon-c{
    color:#666;
  }
</style>


// WEBPACK FOOTER //
// src/components/introduction.vue